import update from "immutability-helper";
import * as actionTypes from "../constants/actionTypes";

const initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: {},
  results: {
    sections: [],
    specialFeatures: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case (actionTypes.GET_SECTIONS): {
      return {
        ...state,
        isLoading: true,
      };
    }

    case (actionTypes.GET_SECTIONS_SUCCESS): {
      const newState = {
        ...state,
        isFinished: true,
        isLoading: false,
        isError: false,
      };

      return update(newState, {
        results: {
          $merge: {
            sections: action.payload,
          },
        },
      });
    }

    case actionTypes.SET_SECTION: {
      return {
        ...state,
        data: {
          ...state.data,
          section: action.section,
        },
      };
    }

    case actionTypes.GET_SECTION_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          section: action.payload,
        },
      };

    case actionTypes.SET_LAST_SEEN: {
      return {
        ...state,
        data: {
          ...state.data,
          lastSeen: action.lastSeen,
        },
      };
    }

    case (actionTypes.GET_SECTIONS_ERROR): {
      return {
        ...state,
        isError: true,
        isLoading: false,
        isFinished: true,
        error: action.payload,
      };
    }

    case (actionTypes.GET_SPECIAL_FEATURES): {
      return {
        ...state,
        isLoading: true,
      };
    }

    case (actionTypes.GET_SPECIAL_FEATURES_SUCCESS): {
      const newState = {
        ...state,
        isFinished: true,
        isLoading: false,
        isError: false,
      };

      return update(newState, {
        results: {
          $merge: {
            specialFeatures: action.payload,
          },
        },
      });
    }

    case (actionTypes.GET_SPECIAL_FEATURES_ERROR): {
      return {
        ...state,
        isError: true,
        isLoading: false,
        isFinished: true,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/navigation.js